import React from 'react';
import { Alert as AlertAD } from 'antd';

function Alert(props) {
  // eslint-disable-next-line react/prop-types
  const { title, className, ...restProps } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <AlertAD showIcon closable {...restProps} className={className} />
  );
}

Alert.defaultProps = {
  className: ''
};

export default Alert;
